<template>
  <div>
    <!-- Trigger Button -->
    <b-button v-if="shouldShow" v-b-modal.warning-list size="sm" variant="warning" @click="showModal = true">
      <feather-icon size="20" icon="AlertTriangleIcon" />
    </b-button>

    <!-- Modal -->
    <b-modal id="warning-list" title="⚠ Page ID Mismatch Detected" size="lg" centered hide-footer>
      <div class="d-flex justify-content-between">
        <div v-if="onlyInProject.length" class="w-50 pr-3 border-right">
          <h6>Only in Project:</h6>
          <ul>
            <li v-for="id in onlyInProject" :key="'proj-' + id">{{ id }}</li>
          </ul>
        </div>

        <div v-if="onlyInPortal.length" class="w-50 pl-3">
          <h6>Only in Portal:</h6>
          <ul>
            <li v-for="id in onlyInPortal" :key="'cms-' + id">{{ id }}</li>
          </ul>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import router from "@/router/index";
export default {
  data() {
    return {
      portalData: [],
      nonEssentialPageNames: [
        "processing",
        "error-404",
        "auth-login",
        "misc-not-authorized",
        "global-iconPreview"
      ],
    };
  },
  created() {
    this.getPortalData();
  },
  computed: {
    projectPages() {
      const projectPages = router.options.routes
        .map((item) => this.getLeafNodes(item, "name"))
        .flat()
        .filter(Boolean)
        .filter((item) => !this.nonEssentialPageNames.includes(item));
      return projectPages;
    },
    onlyInProject() {
      const onlyInProject = this.projectPages.filter((id) => !this.portalData.includes(id));
      return onlyInProject;
    },
    onlyInPortal() {
      const onlyInPortal = this.portalData.filter((id) => !this.projectPages.includes(id));
      return onlyInPortal;
    },
    shouldShow() {
      return process.env.NODE_ENV === "development" && (this.onlyInProject.length || this.onlyInPortal.length);
    },
  },
  methods: {
    collectPageIds(nodes) {
      const result = [];

      function traverse(nodeArray) {
        for (const node of nodeArray) {
          if (node.pageType === "StandardPage") {
            result.push(node.id);
          }
          if (node.children && Array.isArray(node.children)) {
            traverse(node.children);
          }
        }
      }

      traverse(nodes);
      return result;
    },
    getLeafNodes(node, key) {
      const leaves = [];

      function traverse(current) {
        if (!current.children || current.children.length === 0) {
          leaves.push(current[key]);
          return;
        }

        current.children.forEach((child) => traverse(child));
      }

      traverse(node);
      return leaves;
    },
    getPortalData() {
      const portalData = this.$store.getters["adinSettings/getPortalRoutes"];
      if (portalData) {
        this.portalData = portalData;
        return;
      }
      this.$http.get("/global/page/list").then((res) => {
        const portalRoutes = res.data.pages;
        this.portalData = this.collectPageIds(portalRoutes);
        this.$store.commit('adinSettings/setPortalRoutes', this.portalData)
      }).catch(() => {
        this.portalData = [];
      });
    }
  }
};
</script>
